<template>
    <vx-card :title="`Detail Receive`">
        <div class="mb-6 vx-row">
            <vs-button @click="handleBack()" class="mt-2 ml-4" color="danger" icon-pack="feather"
                icon="icon-arrow-left">Back</vs-button>
        </div>
        <div class="flex md:flex-row">
            <div class="w-full pr-6 md:basis-1/2">
                <div class="mb-6 vx-row">
                    <div class="flex items-center w-full vx-col sm:w-1/6">
                        <span>Warehouse Code</span>
                    </div>
                    <div class="w-full vx-col sm:w-5/6">
                        <vs-input :value="this.form.warehouse.code + ' - ' + this.form.warehouse.name" disabled
                            :readonly="true" class="w-full bg-grey-light"></vs-input>
                    </div>
                </div>
                <div class="mb-6 vx-row">
                    <div class="flex items-center w-full vx-col sm:w-1/6">
                        <span>Supplier</span>
                    </div>
                    <div class="w-full vx-col sm:w-5/6">
                        <vs-input :value="this.form.supplier_code + ' - ' + this.form.supplier_name" disabled
                            :readonly="true" class="w-full bg-grey-light"></vs-input>
                    </div>
                </div>
                <div class="mb-6 vx-row">
                    <div class="flex items-center w-full vx-col sm:w-1/6">
                        <span>Purchase Data</span>
                    </div>
                    <div class="w-full vx-col sm:w-5/6">
                        <vs-input :value="this.form.po_code" disabled :readonly="true"
                            class="w-full bg-grey-light"></vs-input>
                    </div>
                </div>
                <div class="mb-6 vx-row">
                    <div class="flex items-center w-full vx-col sm:w-1/6">
                        <span>GR Document Number</span>
                    </div>
                    <div class="w-full vx-col sm:w-5/6">
                        <vs-input :value="this.form.code || 'auto generated'" disabled :readonly="true"
                            class="w-full bg-grey-light"></vs-input>
                    </div>
                </div>
                <div class="mb-6 vx-row">
                    <div class="flex items-center w-full vx-col sm:w-1/6">
                        <span>Posting Date</span>
                    </div>
                    <div class="w-full vx-col sm:w-5/6">
                        <vs-input :value="formatDate(form.date)" disabled :readonly="true"
                            class="w-full bg-grey-light"></vs-input>
                    </div>
                </div>
                <div class="mb-6 vx-row">
                    <div class="flex items-center w-full vx-col sm:w-1/6">
                        <span>Delivery Note Number</span>
                    </div>
                    <div class="w-full vx-col sm:w-5/6">
                        <vs-input :value="form.delivery_order_number" disabled :readonly="true"
                            class="w-full bg-grey-light" />
                    </div>
                </div>
                <div class="mb-6 vx-row">
                    <div class="flex items-center w-full vx-col sm:w-1/6">
                        <span>Delivery Note Date</span>
                    </div>
                    <div class="w-full vx-col sm:w-5/6">
                        <vs-input :value="formatDate(form.dn_date)" disabled :readonly="true"
                            class="w-full bg-grey-light"></vs-input>
                    </div>
                </div>
                <div class="mb-6 vx-row">
                    <div class="flex items-center w-full vx-col sm:w-1/6">
                        <span>Note</span>
                    </div>
                    <div class="w-full vx-col sm:w-5/6">
                        <vs-textarea :value="form.notes" disabled :readonly="true" width="100%" />
                    </div>
                </div>
                <div class="mb-6 vx-row">
                    <div class="flex items-center w-full vx-col sm:w-1/6">
                        <span>Log Approval</span>
                    </div>
                    <div class="w-full vx-col sm:w-5/6">
                        <table style="width: 100%; border-collapse: collapse;">
                            <thead>
                                <tr style="background-color: #f3f4f6;">
                                    <th style="border: 1px solid #d1d5db; padding: 8px 12px; text-align: left;">Time
                                    </th>
                                    <th style="border: 1px solid #d1d5db; padding: 8px 12px; text-align: left;">User
                                    </th>
                                    <th style="border: 1px solid #d1d5db; padding: 8px 12px; text-align: left;">Status
                                    </th>
                                    <th style="border: 1px solid #d1d5db; padding: 8px 12px; text-align: left;">Note
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(log, index) in form.approval_logs" :key="index"
                                    :style="{ backgroundColor: index % 2 === 0 ? '#ffffff' : '#f9fafb' }">
                                    <td style="border: 1px solid #d1d5db; padding: 8px 12px;">{{
                                        formatDateTime(log.created_at) }}</td>
                                    <td style="border: 1px solid #d1d5db; padding: 8px 12px;">{{ log.personal_name }}
                                    </td>
                                    <td style="border: 1px solid #d1d5db; padding: 8px 12px;">{{ log.type }}</td>
                                    <td style="border: 1px solid #d1d5db; padding: 8px 12px;">{{ log.notes }}</td>
                                </tr>
                                <tr v-if="!form.approval_logs || form.approval_logs.length === 0">
                                    <td colspan="4"
                                        style="border: 1px solid #d1d5db; padding: 8px 12px; text-align: center; color: #9ca3af;">
                                        No approval logs found
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="w-full md:basis-1/2">
                <div class="mb-6 vx-row">
                    <vs-divider>
                        List Attachment
                    </vs-divider>
                    <vs-list>
                        <vs-list-item v-for="(item, index) in form.attachment" :key="index" :title="item.name"
                            class="flex">
                            <div class="flex">
                                <a @click.stop="downloadFileAwsS3(item.path)"><vs-button color="success" type="flat"
                                        icon="file_download"></vs-button></a>
                            </div>
                        </vs-list-item>
                    </vs-list>
                </div>
            </div>
        </div>
        <div class="mb-6 vx-row">
            <div class="w-full">
                <table width="100%" class="vs-table vs-table--tbody-table">
                    <thead class="vs-table--thead">
                        <tr>
                            <th colspan="5">Po Data</th>
                            <th colspan="2">GR Data</th>
                            <th>Check Data (Batch/ED)</th>
                        </tr>
                        <tr>
                            <th width="8%">
                                <div>Supplier</div>
                                <div>SKU Code</div>
                            </th>
                            <th width="8%">
                                <div>Internal</div>
                                <div>SKU Code</div>
                            </th>
                            <th width="20%">
                                <div>Internal</div>
                                <div>SKU Description</div>
                            </th>
                            <th width="5%">HU</th>
                            <th width="5%">Qty</th>
                            <th width="5%">HU</th>
                            <th width="5%">Qty</th>
                            <th>Expired Date</th>
                            <th>Batch</th>
                            <th>Check Status</th>
                            <th>Shelf Life Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in filteredLines" :key="index" style="padding-bottom: 5px">
                            <td class="td vs-table--td" style="padding: 5px">
                                <vs-input :value="item.po_item_unit.sku_code_supplier" :readonly="true" disabled
                                    class="w-full bg-grey-light"></vs-input>
                            </td>
                            <td class="td vs-table--td" style="padding: 5px">
                                <vs-input :value="item.po_item_unit.sku_code" :readonly="true" disabled
                                    class="w-full bg-grey-light" />
                            </td>
                            <td class="td vs-table--td" style="padding: 5px">
                                <vs-input :value="item.po_item_unit.item_name" :readonly="true" disabled
                                    class="w-full bg-grey-light"></vs-input>
                            </td>
                            <td class="td vs-table--td" style="padding: 5px">
                                <vs-input :value="item.po_item_unit.name" :readonly="true" disabled
                                    class="w-full bg-grey-light" />
                            </td>
                            <td class="td vs-table--td" style="padding: 5px">
                                <vs-input :value="item.po_quantity" :readonly="true" disabled
                                    class="w-full bg-grey-light"></vs-input>
                            </td>
                            <td class="td vs-table--td" style="padding: 5px">
                                <vs-input :value="item.item_unit ? item.item_unit.name : ''" :readonly="true" disabled
                                    class="w-full bg-grey-light" />
                            </td>
                            <td class="td vs-table--td" style="padding: 5px">
                                <vs-input :value="item.quantity" :readonly="true" disabled
                                    class="w-full bg-grey-light" />
                            </td>
                            <td class="td vs-table--td" style="padding: 5px">
                                <vs-input :value="item.expired_date" :readonly="true" disabled
                                    class="w-full bg-grey-light" />
                            </td>
                            <td class="td vs-table--td" style="padding: 5px">
                                <vs-input :value="item.batch_external" :readonly="true" disabled
                                    class="w-full bg-grey-light" />
                            </td>
                            <td class="td vs-table--td" style="padding: 5px">
                                <vs-input :value="item.check_status ? item.check_status.name : ''" :readonly="true"
                                    disabled class="w-full bg-grey-light" />
                            </td>
                            <td class="td vs-table--td" style="padding: 5px">
                                <vs-textarea class="w-full bg-grey-light" :readonly="true" disabled
                                    style="width: fit-content;"
                                    :value="`${item.shelf_life_status}\n${getShelfLifeLabel(item)}`">
                                </vs-textarea>
                                <!-- <vs-input :value="item.shelf_life_status" :readonly="true" disabled
                                    class="w-full bg-grey-light" /> -->
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="mt-6 vx-row" v-if="this.mode == 'approval' && form.status_approval == 1">
            <div style="margin-left: auto; margin-right: auto;">
                <vs-button class="mb-2 mr-3" color="warning" @click="handleInquiry(form.id)">Inquiry</vs-button>
                <vs-button class="mb-2 mr-3" @click="handleApprove(form.id)">Approve</vs-button>
                <vs-button class="mb-2 mr-3" color="danger" @click="handleReject(form.id)">Reject</vs-button>
            </div>
        </div>

        <vs-prompt :active.sync="dialog.approve" title="Approve" @accept="submitApprove" @cancel="resetDialog">
            <vs-textarea v-model="dialog.note" placeholder="Note approval (optional)" width="100%" />
        </vs-prompt>

        <vs-prompt :active.sync="dialog.reject" title="Reject" color="danger" @accept="submitReject"
            @cancel="resetDialog">
            <vs-textarea v-model="dialog.note" placeholder="Note rejection (optional)" width="100%" />
        </vs-prompt>

        <vs-prompt :active.sync="dialog.inquiry" title="Inquiry" color="warning" @accept="submitInquiry"
            @cancel="resetDialog">
            <vs-textarea v-model="dialog.note" placeholder="Note inquiry (optional)" width="100%" />
        </vs-prompt>
    </vx-card>
</template>

<script>
import Date from "@/components/Date.vue";
import CustomMSelect from "@/components/CustomMultiSelect.vue";
import vSelect from "vue-select";
import moment from "moment";
import Datepicker from "vuejs-datepicker";

export default {
    components: {
        Date,
        CustomMSelect,
        vSelect,
        Datepicker,
    },
    mounted() {
        this.id = this.$route.params.id;
        this.mode = this.$route.params.mode;
        if (this.id) {
            this.initData();
        } else {
            this.$vs.loading();
            setTimeout(this.$vs.loading.close, 3200);
        }
    },
    data() {
        return {
            checkOptions: [{
                value: 0,
                name: "Good",
            }, {
                value: 1,
                name: "Damaged",
            }, {
                value: 2,
                name: "Expired",
            }],
            id: null,
            po_type: null,
            mode: null,
            dialog: {
                approve: false,
                reject: false,
                inquiry: false,
                note: '',
            },
            form: {
                purchase_order_id: null,
                warehouse: { code: '', name: '' },
                attachment: [],
                dn_date: null,
                purchaseData: null,
                code: null,
                date: null,
                notes: null,
                notes_approval: null,
                delivery_order_number: null,
                purchase_date: null,
                lines_dto: [],
            },
        }
    },
    computed: {
        filteredLines() {
            return this.form.lines_dto.filter(item => Number(item.quantity) !== 0)
        }
    },
    methods: {
        formatDate(date) {
            return date ? moment(date).format('YYYY-MM-DD') : ''
        },
        formatDateTime(date) {
            return date ? moment.utc(date).format('YYYY-MM-DD HH:mm:ss') : ''
        },
        getShelfLifeStatus(item) {
            const gr_date = this.form.date ? moment(this.form.date).startOf('day') : moment().startOf('day')
            const exp_date = item.expired_date ? moment(item.expired_date).startOf('day') : null
            const shelf_life = item.shelf_life_day ? Number(item.shelf_life_day) : 0

            if (!exp_date) return '-'

            const diff = exp_date.diff(gr_date, 'days')

            if (diff >= shelf_life) {
                return { status: `Passed (${diff} Day)`, passed: 1 }
            } else {
                return { status: `Failed (${diff} Day)`, passed: 0 }
            }
        },
        getShelfLifeLabel(line) {
            if (!line.shelf_life_status) return ''
            if (line.shelf_life_id == 0) return ''
            if (line.shelf_life_status.includes('Passed')) {
                return `Shelf Life >= ${line.shelf_life_day} days`
            }
            return `Shelf Life < ${line.shelf_life_day} days`
        },
        handleBack() {
            this.$vs.loading();
            if (this.mode == 'approval') {
                this.$router.push({
                    name: this.$store.state.inbound.purchaseOrder.baseRouterName + ".approval",
                });
            } else {
                this.$router.push({
                    name: this.$store.state.inbound.purchaseOrder.baseRouterName,
                });
            }
            this.$vs.loading.close();
        },
        initData() {
            this.$vs.loading();
            this.$http
                .get(`${this.$store.state.inbound.purchaseOrder.baseUrlPath}/receive/create/purchase-order/${this.id}`)
                .then((resp) => {
                    if (resp.code == 200) {
                        this.$vs.loading.close();
                        this.po_type = resp.data.po_type_id
                        this.form = resp.data;

                        if (!this.form.notes_approval) {
                            this.$set(this.form, 'notes_approval', null)
                        }

                        this.form.lines_dto.forEach((item, idx) => {
                            item.check_status = this.checkOptions[item.is_damaged]
                            const statusResult = this.getShelfLifeStatus(item)
                            this.$set(this.form.lines_dto[idx], 'shelf_life_status', statusResult.status)
                            this.$set(this.form.lines_dto[idx], 'shelf_life_passed', statusResult.passed)
                        })
                    } else {
                        this.$vs.loading.close();
                    }
                });
        },
        resetDialog() {
            this.dialog.note = ''
            this.dialog.approve = false
            this.dialog.reject = false
            this.dialog.inquiry = false
        },
        handleApprove(id) {
            this.dialog.approve = true
        },
        handleReject(id) {
            this.dialog.reject = true
        },
        handleInquiry(id) {
            this.dialog.inquiry = true
        },
        submitApprove() {
            this.$vs.loading();
            this.$http.patch(`${this.$store.state.inbound.purchaseOrder.baseUrlPath}/receive/chg-status/approved/` + this.form.id, {
                note: this.dialog.note
            })
                .then((resp) => {
                    this.$vs.loading.close();
                    if (resp.code == 200) {
                        this.$vs.dialog({
                            type: "alert",
                            color: "success",
                            title: `Success`,
                            text: resp.message,
                            accept: () => { this.handleBack(); }
                        });
                    } else {
                        this.$vs.dialog({
                            type: "alert",
                            color: "danger",
                            title: `Unauthorized`,
                            text: resp.message,
                        });
                    }
                    this.resetDialog()
                });
        },
        submitReject() {
            this.$vs.loading();
            this.$http.patch(`${this.$store.state.inbound.purchaseOrder.baseUrlPath}/receive/chg-status/rejected/` + this.form.id, {
                note: this.dialog.note
            })
                .then((resp) => {
                    this.$vs.loading.close();
                    if (resp.code == 200) {
                        this.$vs.notify({
                            color: "success",
                            title: "Success",
                            text: "The data was successfully rejected",
                            position: "top-right",
                            iconPack: "feather",
                            icon: "icon-x-circle",
                        });
                    } else {
                        this.$vs.notify({
                            color: "danger",
                            title: "Error",
                            text: resp.message,
                            position: "top-right",
                            iconPack: "feather",
                            icon: "icon-x-circle",
                        });
                    }
                    this.resetDialog()
                    this.handleBack();
                })
                .catch((error) => {
                    this.$vs.loading.close();
                    this.$vs.notify({
                        color: "danger",
                        title: "Error",
                        text: error,
                        position: "top-right",
                        iconPack: "feather",
                        icon: "icon-x-circle",
                    });
                });
        },
        submitInquiry() {
            this.$vs.loading();
            this.$http.patch(`${this.$store.state.inbound.purchaseOrder.baseUrlPath}/receive/chg-status/inquiry/` + this.form.id, {
                note: this.dialog.note
            })
                .then((resp) => {
                    this.$vs.loading.close();
                    if (resp.code == 200) {
                        this.$vs.notify({
                            color: "success",
                            title: "Success",
                            text: "The data was successfully inquired",
                            position: "top-right",
                            iconPack: "feather",
                            icon: "icon-x-circle",
                        });
                    } else {
                        this.$vs.notify({
                            color: "danger",
                            title: "Error",
                            text: resp.message,
                            position: "top-right",
                            iconPack: "feather",
                            icon: "icon-x-circle",
                        });
                    }
                    this.resetDialog()
                    this.handleBack();
                })
                .catch((error) => {
                    this.$vs.loading.close();
                    this.$vs.notify({
                        color: "danger",
                        title: "Error",
                        text: error,
                        position: "top-right",
                        iconPack: "feather",
                        icon: "icon-x-circle",
                    });
                });
        },
    },
}
</script>

<style scoped>
td.td.vs-table--td {
    vertical-align: text-top !important;
}

.vs-input--input:disabled,
input:disabled {
    pointer-events: auto !important;
}

.vs-dialog-success .vs-dialog footer .vs-button-primary {
    display: none;
}
</style>